export default {
  zh: {
    clickCopy: "点击复制",
    copy: "复制",
    copySuccess: "复制成功",
  },
  en: {
    clickCopy: "Copy",
    copy: "Copy",
    copySuccess: "Successfully Copied",
  },
};



// WEBPACK FOOTER //
// ./src/components/inviteUrl/lang.js